import { BulkEditProgress } from 'src/WebApiController';

export const hasCountsByEntity = (
  countsByEntity: BulkEditProgress['countsByEntity'] | undefined
): boolean => {
  if (!countsByEntity) return false;

  return Array.from(Object.values(countsByEntity)).length > 0;
};
